"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var FileSaver = require("file-saver");
var get_1 = require("../utils/get");
var formatter_1 = require("../utils/formatter");
var object_1 = require("../utils/object");
var typeChecks_1 = require("../utils/typeChecks");
var CsvDownloadHelper = /** @class */ (function () {
    function CsvDownloadHelper(inputs, options, queryStore) {
        var _this = this;
        if (inputs === void 0) { inputs = {}; }
        this.quote = '\x22';
        this.newLine = '\r\n';
        this.defaultSeparator = '\x2C';
        this.getQueryValue = function (query, defaultValue) {
            return (query && _this.queryStore && _this.queryStore.query(query)) || defaultValue;
        };
        this.cleanOutput = function (response) {
            var charsToReplace = [
                {
                    source: ' ',
                    replacement: ' ',
                },
            ];
            charsToReplace.forEach(function (charToReplace) {
                var source = charToReplace.source, replacement = charToReplace.replacement;
                response = response.split(source).join(replacement);
            });
            response = response.replace(/<[^>]*>?/gm, '');
            return response;
        };
        this.getRowText = function (row) {
            return row.map(_this.getCellText).join(_this.separator);
        };
        this.getCellText = function (value) {
            return "" + _this.quote + value.split(_this.quote).join("" + _this.quote + _this.quote) + _this.quote;
        };
        this.getBaseFormatter = function (row) {
            var currency = get_1.get(row, _this.currencyKey) || _this.inputs.currency;
            return {
                currency: currency,
                locale: _this.inputs.culture,
                options: {
                    currency: currency,
                },
            };
        };
        this.getValue = function (row, column, baseFormatter) {
            var key = column.key, format = column.format;
            var rawValue = get_1.get(row, key);
            var response = rawValue;
            if (format) {
                var workingFormat = object_1.deepMergeObjects(baseFormatter, format);
                response = formatter_1.formatter(workingFormat, rawValue);
            }
            return !typeChecks_1.isNullOrUndefined(response) ? response.toString() : '-';
        };
        this.downloadCsv = function (csv, filename) { return __awaiter(_this, void 0, void 0, function () {
            var blob;
            return __generator(this, function (_a) {
                try {
                    blob = new Blob([csv], { type: 'text/csv;charset=utf-16' });
                    FileSaver.saveAs(blob, filename);
                }
                catch (e) {
                    console.warn(e);
                }
                return [2 /*return*/];
            });
        }); };
        this.inputs = inputs;
        this.options = options;
        this.queryStore = queryStore;
    }
    CsvDownloadHelper.prototype.execute = function () {
        return __awaiter(this, void 0, void 0, function () {
            var csvText, filename;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        csvText = this.csvText;
                        filename = this.filename;
                        return [4 /*yield*/, this.downloadCsv(csvText, filename)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CsvDownloadHelper.prototype, "separator", {
        get: function () {
            return (this.options && this.options.separator) || this.defaultSeparator;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsvDownloadHelper.prototype, "rowsQuery", {
        get: function () {
            return this.options.rowsQuery;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsvDownloadHelper.prototype, "columns", {
        get: function () {
            return this.options.columns || [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsvDownloadHelper.prototype, "currencyKey", {
        get: function () {
            return this.options.currencyKey || 'currency';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsvDownloadHelper.prototype, "rows", {
        get: function () {
            return this.getQueryValue(this.rowsQuery, []);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsvDownloadHelper.prototype, "rowsAsArrays", {
        get: function () {
            var response = [];
            for (var _i = 0, _a = this.rows; _i < _a.length; _i++) {
                var row = _a[_i];
                var baseFormatter = this.getBaseFormatter(row);
                var rowArray = [];
                for (var _b = 0, _c = this.columns; _b < _c.length; _b++) {
                    var column = _c[_b];
                    rowArray.push(this.getValue(row, column, baseFormatter));
                }
                response.push(rowArray);
            }
            return response;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsvDownloadHelper.prototype, "headerRow", {
        get: function () {
            return this.columns.map(function (column) { return column.header || column.key; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsvDownloadHelper.prototype, "csvText", {
        get: function () {
            var fileContent = __spreadArrays([
                this.headerRow
            ], this.rowsAsArrays, this.disclaimerRows);
            var response = fileContent.map(this.getRowText).join(this.newLine);
            response = this.cleanOutput(response);
            return response;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsvDownloadHelper.prototype, "disclaimerRows", {
        get: function () {
            var response = [];
            for (var _i = 0, _a = this.disclaimerQueries; _i < _a.length; _i++) {
                var disclaimerQuery = _a[_i];
                if (disclaimerQuery) {
                    var disclaimer = this.getQueryValue(disclaimerQuery);
                    if (disclaimer) {
                        response.push([disclaimer]);
                    }
                }
            }
            return response;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsvDownloadHelper.prototype, "disclaimerQueries", {
        get: function () {
            return this.options.disclaimers || [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsvDownloadHelper.prototype, "filename", {
        get: function () {
            var filenameQuery = this.options.filename;
            var base = this.getQueryValue(filenameQuery);
            if (base && typeof base === 'string') {
                return "" + base + (!base.endsWith('.csv') ? '.csv' : '');
            }
            return 'data-download.csv';
        },
        enumerable: true,
        configurable: true
    });
    return CsvDownloadHelper;
}());
exports.CsvDownloadHelper = CsvDownloadHelper;
//# sourceMappingURL=CsvDownloadHelper.js.map